import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";

const NotificationsIcon = () => <NotificationsNoneIcon fontSize="large" />;

export default NotificationsIcon;
